<!--table 编辑 -->
<template>
  <div class="custom_table_template2">
    <el-card>
      <el-table :data="listData" style="width: 100%">
        <el-table-column prop="hzxm" label="姓名"> </el-table-column>
        <el-table-column prop="sjh" label="手机号"> </el-table-column>
        <el-table-column prop="zjhm" label="身份证号"> </el-table-column>
        <el-table-column prop="hosPatid" label="病历号"> </el-table-column>
        <el-table-column fixed="right" label="操作" width="190">
          <template slot-scope="scope">
            <el-button
              @click="deleteRow(scope.$index, listData)"
              type="text"
              size="small"
            >
              接诊
            </el-button>
            <!-- @click.native.prevent="deleteRow(scope.$index, tableData)" -->
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <!-- <el-card class="drugsCenter">
      <el-table :data="diagnosis" style="width: 100%">
        <el-table-column label="诊断信息">
          <template slot-scope="scope">
            <el-autocomplete
              class="inline-input"
              v-model="state1"
              :fetch-suggestions="querySearch"
              placeholder="请输入病历名称"
              @select="handleSelect"
            ></el-autocomplete>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" header-align="right">
          <template slot-scope="scope">
            <div style="display: flex; justify-content: space-between">
              <el-link
                icon="el-icon-plus"
                size="mini"
                type="primary"
                @click="handleAdd(scope.$index, scope.row)"
                :underline="false"
                style="font-size: 14px; margin-left: 40px"
              ></el-link>
              <el-link
                icon="el-icon-delete"
                size="mini"
                @click="handleDelete(scope.$index, scope.row)"
                type="danger"
                :underline="false"
              ></el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-table :data="drugs" style="width: 100%">
        <el-table-column label="药品信息">
          <template slot-scope="scope">
            <el-autocomplete
              v-model="state2"
              :fetch-suggestions="querySearch"
              placeholder="请输入药品名称"
              @select="handleSelect"
            ></el-autocomplete>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" header-align="right">
          <template slot-scope="scope">
            <div style="display: flex; justify-content: space-between">
              <el-link
                icon="el-icon-plus"
                size="mini"
                type="primary"
                @click="handleAdd(scope.$index, scope.row)"
                :underline="false"
                style="font-size: 14px; margin-left: 40px"
              ></el-link>
              <el-link
                icon="el-icon-delete"
                size="mini"
                @click="handleDelete(scope.$index, scope.row)"
                type="danger"
                :underline="false"
              ></el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-card>
        <el-button type="primary">提交</el-button>
        <el-button type="info" plain>重置</el-button>
      </el-card>
    </el-card> -->
  </div>
</template>
<script>
import axiosUtil from "../../utils/AxiosUtils.js";
import { timeStampFormat } from "../../utils/DateFormat.js";
export default {
  data() {
    return {
      pageNum: 1,
      pageSize: 10000,
      diagnosis: [{}],
      drugs: [{}],
      timeout: null,
      restaurants: [],
      state1: "",
      state2: "",
      tdate: "",
      patientShow: true,
      listData:[],
      defaultProps: {
        children: "children",
        label: "label",
      },
    };
  },
  created: function () {
    this.tdate = timeStampFormat("yyyy-MM-dd");
  },
  mounted() {
    this.loadDate();
  },
  methods: {
    deleteRow(index, rows) {
      this.$router.push({path: 'operation', query: {ddid: rows[index].ddid}})
    },
    loadDate() {
      let _this=this;
      axiosUtil(
        {
          service: "smarthos.online.outpatient.pack.list.v1",
          docId: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,
          bdate: _this.tdate,
          edate: _this.tdate,
          token: localStorage.getItem("token"),
        },
        ({ code, obj, msg }) => {
          if (code == "0") {
            _this.listData=obj.list;
          }
        }
      );
    },
    //远程加载数据
    loadAllRemote() {
      // debugger;
      let _this = this;
      axiosUtil(
        {
          service: "smarthos.drugs.online.diagnosis.query",
          pageNum: _this.pageNum,
          pageSize: _this.pageSize,
          qKey: _this.state1,
        },
        ({ code, obj, msg }) => {
          if (code == "0") {
            obj.list.map((item) => {
              item.value = item.dicName;
              return item;
            });
            _this.restaurants = obj.list;
          }
        }
      );
    },
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    handleAdd(index, row) {
      this.diagnosis.push({});
    },
    handleDelete(index, row) {
      if (index > 0) {
        this.diagnosis.splice(index, 1);
      }
    },
  },
};
</script>
<style lang="scss">
.custom_table_template2 {
  width: 100%;
  height: 100%;
}
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
.patientLeft {
  width: 50%;
  height: 100%;
  float: left;
}
.drugsCenter {
  width: 50%;
  height: 100%;
  float: right;
}
</style>
